<template>
  <v-container fluid class="billing px-2 px-md-0">
    <v-list subheader dense>
      <h2 class="group-label col-12">Cards</h2>

      <v-list-item
        v-for="(item, index) in paymentMethods"
        :key="index"
        class="card-item"
      >
        <v-list-item-avatar tile size="auto">
          <v-img
            width="56"
            height="38"
            :src="require(`@/assets/${item.brand}.svg`)"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            {{
              "**** **** **** " +
                item.last4 +
                " " +
                item.expMonth +
                "/" +
                item.expYear
            }}
          </v-list-item-title>
        </v-list-item-content>

        <div class="delete_card d-none d-md-block" @click="removeCard(item.id)">
          Delete Card
        </div>
      </v-list-item>
    </v-list>

    <v-dialog v-model="dialog" persistent max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="new_card d-none d-md-inline-block">
          Add New Card
        </div>
        <div class="mt-5 d-block d-md-none d-flex justify-end ">
          <v-btn
            v-bind="attrs"
            v-on="on"
            block
            color="appRed"
            class="white--text d-block d-md-inline-block"
          >
            Add New Card
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </template>
      <Card @close="dialog = false" />
    </v-dialog>
  </v-container>
</template>

<script>
import Card from "./Card.vue";
import { mapState } from "vuex";
export default {
  name: "BillingComponent",
  components: {
    Card
  },
  data: () => ({
    dialog: false,
    items: [
      { title: "**** **** **** 1435 12/22", avatar: "visa.svg" },
      { title: "**** **** **** 1435 12/22", avatar: "visa.svg" }
    ],
    complete: false,
    stripeOptions: {
      style: {
        base: {
          iconColor: "#c4f0ff",
          // color: '#fff',
          fontWeight: 500,
          fontFamily: "Open Sans, sans-serif",
          fontSize: "16px",
          fontSmoothing: "antialiased",
          ":-webkit-autofill": {
            // color: '#fce883',
          },
          "::placeholder": {
            // color: '#87BBFD',
          }
        },
        invalid: {
          iconColor: "#FFC7EE",
          color: "#FFC7EE"
        }
      }
    },
    apiKey:
      "pk_test_51Ie3SIE2G8bCTlZgz1WttGewqmjtO2IcTO5CmbTlg01B9iXM3czMGBiFy0hbRco3w27GxKRddTc7HQRupdGb25sx00t8ntJfeB"
  }),
  computed: {
    ...mapState({
      paymentMethods: state => state.stripe.paymentMethods
    })
  },
  mounted() {
    this.$store.dispatch("stripe/LOAD_PAYMENT_METHODS");
  },
  methods: {
    removeCard(id) {
      this.$store.dispatch("stripe/DELETE_PAYMENT_METHOD", id);
    }
  }
};
</script>
<style scoped lang="scss" src="./Billing.scss"></style>
